import React from 'react';
import { ShoppingCart } from '@phosphor-icons/react';
import ComingSoonPage from './ComingSoonPage';

const LogisticsProcurementPage = () => (
  <ComingSoonPage
    Icon={ShoppingCart}
    tag="PPE · OIL-SPILL · INFRA"
    title="Procurement catalogue is coming in Phase 3."
    phase="Phase 3 · Procurement / e-commerce"
    testid="ls-procurement"
    bullets={[
      'PPE (hi-vis, hard hats, boots, respirators, goggles)',
      'Oil-spill response: containment booms, skimmers, dispersant, absorbents',
      'Infrastructure: pipes, pumps, generators, lighting, fencing',
      'Multi-vendor prices at different price points — procurement due-diligence',
      'Lead-time selector: instant / 2 hrs / next day with rush surcharges',
      'Admin-editable global templates that clone into each exercise',
    ]}
  />
);
export default LogisticsProcurementPage;
